<template>
  <a-card :bordered="false" title="旅游保险">
    <search-page-view
      :itemNames="['search_orderNo','search_insuranceNo','search_status']"
      :col="2"
      :buttonItems="['add-button']"
      :query-params="queryParams"
      params-path="insuranceTying/selectOrderList"
      base-key="serviceUrl"
      :columns="columns"
    >
      <a-form-item slot="search_orderNo" label="关联商品订单号" v-bind="searchItemLayout">
        <a-input v-model="queryParams.orderNo" placeholder="请输入"></a-input>
      </a-form-item>
      <a-form-item slot="search_insuranceNo" label="保险订单号" v-bind="searchItemLayout">
        <a-input v-model="queryParams.insuranceNo" placeholder="请输入"></a-input>
      </a-form-item>
      <a-form-item slot="search_status" label="支付状态" v-bind="searchItemLayout">
        <a-select
          style="width: 100%"
          v-model="queryParams.status"
          placeholder="请选择"
        >
          <a-select-option v-for="item in proCategoryList" :key="item.code" :value="item.code">{{ item.name }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-button slot="add-button" style="margin-left: 8px" @click="toEditor">保险搭售设置</a-button>
      <a-button slot="add-button" style="margin-left: 8px" @click="goInsuranceLogin">前往保险后台</a-button>
    </search-page-view>
    <a-modal
      title="保险搭售设置"
      :width="500"
      v-model="visibleLink"
      @cancel="visibleLink=false"
      :destroyOnClose='true'
      :footer="null"
    >
      <a-form-item label="自动搭售" v-bind="customFormItemLayout">
        <a-radio-group name="radioGroup" @change="onChange" v-model="tyingSetting">
          <a-radio :value="1">开启</a-radio>
          <a-radio :value="0">关闭</a-radio>
        </a-radio-group>
      </a-form-item>
      <p style="padding-left:15px;color:red">*目前仅支持“国内跟团”、“出境跟团”二种商品类型</p>
      <a-button style="margin:20px 0 0 20px" type="primary" @click="save">保存设置</a-button>
    </a-modal>
  </a-card>
</template>

<script>
import SkipOtherHelper from '../../../../utils/helper/SkipOtherHelper'
import searchForm from '../../../../utils/mixins/searchFormMixins'

export default {
  name: 'InsuranceList',
  mixins: [searchForm],
  data() {
    return {
      pageType: 1,
      searchItemList: ['search_proId', 'p_proId', 'search_proType'],
      selectedDate: undefined,
      proCategoryList: [
        { name: '全部', code: 0 },
        { name: '等待出单', code: 1 },
        { name: '出单成功', code: 2 },
        { name: '出单失败', code: 3 }
      ],
      queryParams: {},
      columns: [
        {
          title: '保险订单号',
          dataIndex: 'insuranceNo'
        },
        {
          title: '关联商品订单号',
          dataIndex: 'orderNo'
        },
        {
          title: '下单时间',
          dataIndex: 'createTime'
        },
        {
          title: '商品名称',
          dataIndex: 'product_name'
        },
        {
          title: '订单金额',
          dataIndex: 'total_price',
          width: '160px'
        },
        {
          title: '订单状态',
          dataIndex: 'status',
          width: '160px'
        }
      ],
      form: this.$form.createForm(this),
      visibleLink: false,
      customFormItemLayout: {
        labelCol: {
          span: 5
        },
        wrapperCol: {
          span: 15
        }
      },
      tyingSetting: 0,
      insuranceId: 0
    }
  },
  created() {
    this.queryParams.merchantId = this.$store.getters.userInfo.merchantId
    this.queryParams.platformId = this.getPlatformConfig().platformId
  },
  mounted() {

  },
  methods: {
    //去保险网站
    goInsuranceLogin() {
      let params = {
        merchantId: this.queryParams.merchantId,
        platformId: this.queryParams.platformId
      }
      this.getHttpServices().getServerApiService().post('insurance/getInsuranceAccountInfo', params)
        .then(res => {
          setTimeout(() => {
            window.open(res)
          }, 500)
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    onChange(e) {
      this.tyingSetting = e.target.value
    },
    toEditor() {
      this.visibleLink = true
      this.getInsuranceRegistered()
    },
    getInsuranceRegistered() { //保险搭售查询
      let params = {
        merchantId: this.queryParams.merchantId,
        platformId: this.queryParams.platformId
      }
      this.getHttpServices().getServerApiService().post('insuranceTying/getInsuranceRegistered', params)
        .then(res => {
          this.tyingSetting = res.tyingSetting
          this.insuranceId = res.insuranceId
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    save() { //保存设置
      let params = {
        merchantId: this.queryParams.merchantId,
        platformId: this.queryParams.platformId,
        insuranceId: this.insuranceId,
        tyingSetting: this.tyingSetting
      }
      this.getHttpServices().getServerApiService().post('insuranceTying/setting/update', params)
        .then(res => {
          this.visibleLink = false
          this.$message.success('设置成功')
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    }
  }
}
</script>
<style scoped>
</style>